import { prepareBootLoaderScene, showBootError } from "./bootLoader";
import { bootstrapPotok } from "./bootstrapRuntime";

try {
  await bootstrapPotok({
    loadMain: () => import("./main"),
    loadPlatformSdk: () => loadPlatformSdk("https://st.max.ru/js/max-web-app.js"),
    onMainReady: prepareBootLoaderScene
  });
} catch (error) {
  showBootError(error);
}

function loadPlatformSdk(source: string): Promise<void> {
  if (window.WebApp?.initData) return Promise.resolve();
  return new Promise((resolve) => {
    const script = document.createElement("script");
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      resolve();
    };
    const timeout = window.setTimeout(finish, 10_000);
    script.src = source;
    script.async = true;
    script.dataset.potokMaxSdk = "true";
    script.onload = () => {
      window.dispatchEvent(new Event("potok:max-sdk-ready"));
      finish();
    };
    script.onerror = finish;
    document.head.append(script);
  });
}
